import React from 'react';

const AssociatedWithSkeleton = () => {
  return (
    <div className="flex flex-col gap-2 md:mt-3 mb-6">
      <div className="bg-gray-200 h-4 w-24 rounded animate-pulse" />
      <div className="flex flex-row gap-2 items-center">
        <div className="bg-gray-200 w-[40px] h-[40px] rounded-lg animate-pulse" />
        <div className="bg-gray-200 h-5 w-32 rounded animate-pulse" />
      </div>
    </div>
  );
};

export default AssociatedWithSkeleton;
